import React from "react";
import JobCards from "./JobCards";
import "./AppliedJob.css";
export default function AppliedJob() {
  return (
    <>
      <div className="appliendJob_main">
        <div className="applied-job-cards">
          <JobCards />
        </div>
      </div>
    </>
  );
}
